
 
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

window.Alpine = Alpine
 
Alpine.start()
Alpine.plugin(collapse)


document.addEventListener('DOMContentLoaded', function() {
    // Check the current language on page load
    const lang = localStorage.getItem('lang') || 'en'; // Default to 'en' if no language set

    // Set the initial language based on localStorage
    setLanguage(lang);

    // Detect language change button click
    const languageButtons = document.querySelectorAll('#change-language');
    languageButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const selectedLang = button.getAttribute('data-lang'); // Get the selected language

            // Update localStorage with the new language
            localStorage.setItem('lang', selectedLang);

            // Optionally, you could send the language to WordPress via AJAX here
            updateLanguageInWordPress(selectedLang);

            // Change the content based on the selected language
            setLanguage(selectedLang);
        });
    });

    // Function to change the language (e.g., changing text, loading new translations)
    function setLanguage(lang) {
        // You can modify the page content based on the language
        if (lang === 'en') {
            document.body.classList.add('lang-en');
            document.body.classList.remove('lang-zh');
        } else if (lang === 'zh') {
            document.body.classList.add('lang-zh');
            document.body.classList.remove('lang-en');
        }
    }

    // Function to send language change to WordPress via AJAX
    function updateLanguageInWordPress(lang) {
        jQuery.ajax({
            url: my_ajax_url,  // Make sure to localize the AJAX URL in your theme
            method: 'POST',
            data: {
                action: 'set_language',
                lang: lang
            },
            success: function(response) {
                console.log('Language set to: ' + lang);
            }
        });
    }
});
